// Русское склонение числительных — общий помощник (L16, ревью «Сезон» 18.09).
// До этого файла в разных экранах жили свои копии одного и того же правила
// (testWord в ZeitProfile.tsx, plural в ZeitTraining.tsx, ручные тернарники
// в ZeitPulse.tsx/PulseHome.tsx) — здесь одна реализация для новых мест.
//
// Правило: 1, 21, 31… → one; 2–4, 22–24, 32–34… (кроме 12–14) → few;
// всё остальное, включая 0 и 11–14, → many. Слова без формы «мало»
// (глаголы/краткие прилагательные вроде «ждёт/ждут») передаются с
// одинаковым few и many — вызывающая сторона просто повторяет строку.
export function plural(n: number, one: string, few: string, many: string): string {
  const mod10 = Math.abs(n) % 10;
  const mod100 = Math.abs(n) % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}
